import React from 'react';
import './DrinkCard.css';

const DrinkCard = ({ drink, onClick }) => {
  return (
    <div className="drink-card" onClick={() => onClick(drink)}>
      <div className="drink-image">
        {drink.image_url ? (
          <img src={drink.image_url} alt={drink.title} />
        ) : (
          <div className="placeholder-image">
            <span>{drink.is_alcoholic ? '🍸' : '🥤'}</span>
          </div>
        )}
        {drink.is_alcoholic && (
          <div className="alcoholic-badge">21+</div>
        )}
      </div>
      <div className="drink-content">
        <h3 className="drink-title">{drink.title}</h3>
        <div className="drink-meta">
          {drink.prep_time && (
            <span className="meta-item">⏱️ {drink.prep_time} min</span>
          )}
          {drink.alcohol_content && (
            <span className="meta-item">🍷 {drink.alcohol_content}%</span>
          )}
        </div>
        {drink.description && (
          <p className="drink-description">{drink.description}</p>
        )}
        <div className="drink-tags">
          {drink.tags && drink.tags.map((tag, index) => (
            <span key={index} className="tag">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrinkCard;